import { Modal } from 'bootstrap';

class Speedbump {
  constructor() {
    const modal = document.querySelector('#sbModal');
    const partnerModal = document.querySelector('#sbPartnerModal');

    if (window.ga) {
      [modal, partnerModal].forEach((mod) => {
        mod.querySelector('.speedbump-submit').addEventListener('click', () => {
          window.ga('send','event','Button','Speedbump_Continue',URL,{'noninteraction': 1});
        })
        mod.querySelector('.speedbump-cancel').addEventListener('click', () => {
          window.ga('send','event','Button','Speedbump_Cancel',URL,{'noninteraction': 1});          
        })
      })
    }

    document.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', (evt) => {
        var link = evt.currentTarget;
        var url = link.getAttribute('href');

        if (['sbModalSubmit', 'sbPartnerModalSubmit'].includes(link.getAttribute('id'))) {
          evt.preventDefault();
          window.open(url);

          if (modal)
            Modal.getOrCreateInstance(modal).hide();
          if (partnerModal)
            Modal.getOrCreateInstance(partnerModal).hide();
        } else if (
          link.hostname !== location.hostname
          && Speedbump.partnerUrls.includes(link.hostname)
          && url
          && url.indexOf('#') !== 0
          && (!this.isUriSchema(url))
        ) {
          evt.preventDefault();
          if (partnerModal) {
            Modal.getOrCreateInstance(partnerModal).show();
            partnerModal.querySelector('#sbPartnerModalSubmit').setAttribute('href', url);
          }
        } else if (
          link.hostname !== location.hostname
          && !Speedbump.exclusions.includes(link.hostname)
          && !Speedbump.partnerUrls.includes(link.hostname)
          && url
          && url.indexOf('#') !== 0
          && (!this.isUriSchema(url))
        ) {
          evt.preventDefault();
          if (modal) {
            Modal.getOrCreateInstance(modal).show();
            modal.querySelector('#sbModalSubmit').setAttribute('href', url);
          }
        }
      })
    })
  }

  isUriSchema(url) {
    for (var i in Speedbump.uriSchemes) {
        if (url.indexOf(Speedbump.uriSchemes[i]) > -1) {
            return true;
        }
    }
    return false;
  }
}

Speedbump.uriSchemes = ['javascript:', 'mailto:', 'tel:'];
Speedbump.exclusions = window.wf?.speedbump?.exclusions ?? [];
Speedbump.partnerUrls = window.wf?.speedbump?.partnerUrls ?? [];

window.addEventListener('load', () => {
  const speedbump = new Speedbump();
});
